import React from 'react'
import { connect } from 'react-redux'

import { Container, Divider, Header } from 'semantic-ui-react'

import ContactForm from '../components/ContactForm'
import ShareButton from '../components/ShareButton'

function Contact({ config }) {
	
	return (
		<>
			<Container text style={{ color: '#fff', flex: 1, padding: '2em 0' }}>
				
				<Header as="h1" inverted style={{ marginbottom: '1em' }}>Contact Us</Header>
				
				<ContactForm />
				
				<Divider />
				
				<Header as="h2" inverted style={{ marginbottom: '1em' }}>Contact Us Now At:</Header>
				
				<p><strong>Jacobs Amupolo</strong></p>
				<p><strong><a href="https://www.namlaw.com/" target="_system">www.namlaw.com</a></strong></p>
				
				<p><strong>E-mail:</strong> <a href="mailto:info@namlaw.com">info@namlaw.com</a></p>
				<p><strong>Tel:</strong> +264 61 2555 01</p>
				
				<Divider />
				<Header as="h3" inverted style={{ marginbottom: '1em' }}>Conveyancer:</Header>
				
				<p><strong>Jaco:</strong> <a href="mailto:jaco@namlaw.com">jaco@namlaw.com</a></p>
				
				<Divider />
				<Header as="h3" inverted style={{ marginbottom: '1em' }}>Support staff:</Header>
				
				<p><strong>Julie:</strong> <a href="mailto:transfers@namlaw.com">transfers@namlaw.com</a></p>
				<p><strong>Mari-Lize:</strong> <a href="mailto:bonds@namlaw.com">bonds@namlaw.com</a></p>
				
				<Divider />
				
				<ShareButton />
				
			</Container>
		</>
	)
}

const mapStateToProps = state => ({
	config: state.config.config
})

export default connect(
	mapStateToProps,
	null
)(Contact)
